import FindCar from '@/components/FindCar/FindCar.vue';
import { createInput } from '@formkit/vue';

export const findCarInput = createInput(FindCar, {
  props: [
    'topMakes',
    'regoResultsStepTitle',
    'regoResultsStepContent',
    'makeAndModelResultsStepTitle',
    'makeAndModelResultsStepContent',
    'findCarBtn',
    'regoNotFoundMessage',
    'yearLabel',
    'makeLabel',
    'modelLabel',
    'seriesLabel',
    'bodyLabel',
    'colourLabel',
    'regoInputLabel',
    'showColour',
    'showColourFieldOnList',
    'colourFieldOnListHelpText',
    'colourFieldOnListValidationText',
    'expandMakeAndModelLabel',
    'expandMakeAndModelManualLabel',
    'expandMakeAndModelPreLabel',
    'makeAndModelTitleMessage',
    'icon',
    'title',
    'subTitle',
    'isRoadside',
    'roadsideRegoHelpText',
    'lookUpVehicleManualInfoMessage',
    'formName',
    'tooltipContent',
    'tooltipShowInModal',
    'tooltipModalTitle',
    'profileInfo',
    'showReleaseDate',
  ],
});

export const findCarPlugin = (node: any) => {
  if (node.props.type == 'findCar') {
    node.props.help = '';
  }
};
